import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {IContactTag} from '@routes/events/models/event-model';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {
    ErrorResponse as ErrorResponseLegacy,
    SuccessResponse as SuccessResponseLegacy
} from '@services/api/legacy/response';
import {IContactTags} from '@services/api/legacy/contacttags-service/contacttags-model';
import {InvitedeskApiService} from '@services/api/legacy/invitedesk-api.service';
import {
    AdvancedTemplatesFilterModel
} from '@services/api/dashboard/advanced-templates-service/advanced-templates.model';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-advanced-templates-filter',
    templateUrl: './advanced-templates-filter.component.html',
    styleUrls: ['./advanced-templates-filter.component.scss']
})
export class AdvancedTemplatesFilterComponent implements OnInit {

    public tagsControl = new FormControl<number[]>([]);
    public searchValueControl = new FormControl<string>('');
    public tags: IContactTag[] = [];

    @Output()
    public filterChanged = new EventEmitter<AdvancedTemplatesFilterModel>();

    constructor(private invitedeskApi: InvitedeskApiService) {}

    ngOnInit(): void {
        this.searchValueControl.valueChanges
            .pipe(
            debounceTime(300),
            distinctUntilChanged(),)
            .subscribe(() => this.onFilterChanged());

        this.tagsControl
            .valueChanges
            .subscribe(() => this.onFilterChanged());

        this.getAllTags();
    }

    public getAllTags(): void {
        this.invitedeskApi
            .contacttags
            .getTagsFields()
            .subscribe((res: SuccessResponseLegacy<IContactTags>) => {
                    this.tags = res?.data?.tags;
                },
                (error: ErrorResponseLegacy) => {
                    console.error('show notification', error.error);
                });
    }

    public onFilterChanged(): void {
        const filter = new AdvancedTemplatesFilterModel();
        filter.searchValue = this.searchValueControl.value;
        filter.tagIds = this.tagsControl.value;
        this.filterChanged.emit(filter);
    }
}
